import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import viVN from 'antd/es/locale/vi_VN';
import store from './store/index';

import MainCheck from './containers/MainCheck';

import { I18nextProvider } from 'react-i18next'
import initLng from './constants/initLng';
import { updateMomentLocale, initSentry } from './utils/commonUtils';

import './less/main.less';
import './assets/bootstrap.min.css';
import './assets/style.css';
import './index.css';

updateMomentLocale(initLng.t(`lang`));
initSentry();

ReactDOM.render(
    <Provider store={store}>
        <I18nextProvider i18n={initLng}>
            <Router basename={process.env.PUBLIC_URL}>
                <ConfigProvider locale={viVN}>
                    <MainCheck />
                </ConfigProvider>
            </Router>
        </I18nextProvider>
    </Provider>
    , document.getElementById('root'));
serviceWorker.unregister();
